const template4 = {
	banners: {
		sections: {
			1: {
				animationTypes: ["Horizontal", "Fade"],
				animationSpeed: true,
				pagination: true,
				autoplay: true,
				arrows: true,
				counter: true,
			},
			2: {
				animationTypes: ["Horizontal"],
				animationSpeed: true,
				autoplay: true,
				arrows: true,
				counter: false,
			},
			3: {
				animationTypes: ["Horizontal", "Fade"],
				animationSpeed: true,
				pagination: true,
				autoplay: true,
				arrows: false,
				counter: false,
			},
			5: null,
		},
		pages: {
			Mainpage: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					home_page_main_section: {
						width: 1040,
						height: 348,
					},
					home_page_secondary_section: {
						width: 516,
						height: 424,
					},
				},
			},
			Casino: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					casino_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			CasinoHome: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					casino_home_secondary_section: {
						width: 476,
						height: 250,
						gridAvailable: true,
					},
				},
			},
			LiveCasinopage: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					livecasino_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			RegistrationPage: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					registration_page_side_section: {
						width: 392,
						height: 600,
						gridAvailable: true,
						withNote: true,
					},
				},
			},
			LiveCasinoHome: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					live_casino_home_secondary_section: {
						width: 476,
						height: 250,
						gridAvailable: true,
					},
				},
			},
			TVGamespage: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					tvgames_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			TVGamesHome: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					tv_games_home_secondary_section: {
						width: 476,
						height: 250,
						gridAvailable: true,
					},
				},
			},
			VirtualSportpage: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					virtualsport_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			VirtualSportHome: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					virtual_sport_home_secondary_section: {
						width: 476,
						height: 250,
						gridAvailable: true,
					},
				},
			},
			FastGames: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					fastgames_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			FastGamesHome: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					fast_games_home_secondary_section: {
						width: 476,
						height: 250,
						gridAvailable: true,
					},
				},
			},
			CasinoTournaments: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					casino_tournaments_page_main_section: {
						width: 1920,
						height: 900,
					},
				},
			},
			MyProfile: {
				auth: true,
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					myprofile_popup_main_section: {
						width: 1329,
						height: 90,
					},
				},
			},
			RegistrationPopup: {
				auth: true,
				speceficType: 1,
				settings: {},
				sections: {
					registration_popup_main_section: {
						width: 328,
						height: 90,
						regAltText: true,
					},
				},
			},
			LoginPopup: {
				auth: true,
				speceficType: 1,
				settings: {},
				sections: {
					login_popup_main_section: {
						width: 328,
						height: 90,
					},
				},
			},
			Join: {
				auth: true,
				speceficType: 1,
				speceficDeviceType: 2,
				settings: {},
				sections: {
					join_popup_main_section: {
						width: 992,
						height: 90,
					},
				},
			},
			Sport: {
				settings: {
					defaultAnimationSpeed: 5,
					minAnimationSpeed: 0.5,
					maxAnimationSpeed: 15,
				},
				sections: {
					sport_page_top_section: {
						width: 610,
						height: 836,
						gridAvailable: true,
					},
				},
			},
		},
	},
	fonts: {
		fontFamily: {
			title: "font_family",
			name: "font-family-1",
			defaultValueIndex: 0,
			values: [
				{ name: "'Roboto', sans-serif", label: "Roboto", sampleText: "roboto.svg" },
				{ name: "Arial, Helvetica, sans-serif", label: "Arial", sampleText: "arial.svg" },
				{ name: "Impact, Charcoal, sans-serif", label: "Impact", sampleText: "impact.svg" },
				{ name: "Tahoma, Geneva, sans-serif", label: "Tahoma", sampleText: "tahoma.svg" },
				{ name: "Trebuchet MS, Helvetica, sans-serif", label: "Trebuchet MS", sampleText: "trebuchet_ms.svg" },
				{ name: "Verdana, Geneva, sans-serif", label: "Verdana", sampleText: "verdana.svg" },
				{ name: "MS Sans Serif, Geneva, sans-serif", label: "MS Sans Serif", sampleText: "ms_sans_serif.svg" },
				{ name: "Curier New, Courier, monospace", label: "Curier New", sampleText: "courier_new.svg" },
				{ name: "Lucida Console, Monaco, monospace", label: "Lucida Console", sampleText: "lucida_console.svg" },
				{
					name: "Lucida Sans Unicode,Lucida Grande, monospace",
					label: "Lucida Sans Unicode",
					sampleText: "lucida_sans_unicode.svg",
				},
				{ name: "Georgia, serif", label: "Georgia", sampleText: "georgia.svg" },
				{ name: "Times New Roman, Times, serif", label: "Times New Roman", sampleText: "times_new_roman.svg" },
				{
					name: "Palatino Linotype,Book Antiqua,Palatino, serif",
					label: "Palatino Linotype",
					sampleText: "palatino_linotype.svg",
				},
				{ name: "Comic Sans MS, cursive", label: "Comic Sans MS", sampleText: "comic_sans_ms.svg" },
				{ name: "'IRANSans', sans-serif", label: "Iranian Sans", sampleText: "iran_sans.svg" },
				{ name: "'Open Sans', sans-serif", label: "Open Sans", sampleText: "open_sans.svg" },
				{ name: "'Ubuntu', sans-serif", label: "Ubuntu", sampleText: "ubuntu.svg" },
			],
		},
	},
	cornerRadius: {
		"btn-radius-top-left": "2",
		"btn-radius-top-right": "2",
		"btn-radius-bottom-right": "2",
		"btn-radius-bottom-left": "2",

		"input-radius-top-left": "2",
		"input-radius-top-right": "2",
		"input-radius-bottom-right": "2",
		"input-radius-bottom-left": "2",
	},
	popupColors: {
		backgroundColors: {
			title: "background_colors",
			autoGenerate: true,
			bottomAxis: { start: 0, end: 50 },
			topAxis: { start: 50, end: 100 },
			list: [
				{
					name: "modal-bg-color-1",
					value: "#ffffff",
					visible: true,
					generationStep: 0,
				},
				{
					name: "modal-bg-color-2",
					value: "#f4f4f4",
					visible: true,
					generationStep: 5,
				},
				{
					name: "modal-bg-color-3",
					value: "#e8e8e8",
					visible: true,
					generationStep: 10,
				},
				{
					name: "modal-bg-color-4",
					value: "#c7c7c7",
					visible: true,
					generationStep: 15,
				},
			],
		},
		textColors: {
			title: "text_colors",
			autoGenerate: true,
			bottomAxis: { start: 40, end: 60 },
			topAxis: { start: 60, end: 100 },
			list: [
				{
					name: "modal-text-color-1",
					value: "#1a1a1a",
					visible: true,
					generationStep: 0,
				},
				{
					name: "modal-text-color-2",
					value: "#3d3d3d",
					visible: true,
					generationStep: 20,
				},
				{
					name: "modal-text-color-3",
					value: "#999999",
					visible: true,
					generationStep: 30,
				},
			],
		},
	},
	colors: {
		brandColors: {
			title: "brand_colors",
			list: [
				{
					name: "brand-color-1",
					value: "#432766",
					visible: true,
				},
				{
					name: "brand-color-2",
					value: "#fffc91",
					visible: true,
				},
				{
					name: "brand-color-text",
					value: "#fbfbfb",
					visible: true,
				},
			],
		},

		backgroundColors: {
			title: "background_colors",
			autoGenerate: true,
			bottomAxis: { start: 0, end: 50 },
			topAxis: { start: 50, end: 100 },
			list: [
				{
					name: "background-color-1",
					value: "#261626",
					visible: true,
					generationStep: 0,
				},
				{
					name: "background-color-2",
					value: "#332233",
					visible: true,
					generationStep: 5,
				},
				{
					name: "background-color-3",
					value: "#6c3765",
					visible: true,
					generationStep: 10,
				},
				{
					name: "background-color-4",
					value: "#281128",
					visible: true,
					generationStep: 15,
				},
				{
					name: "background-color-5",
					value: "#583c55",
					visible: true,
					generationStep: 20,
				},
				{
					name: "background-color-6",
					value: "#261626",
					visible: true,
					generationStep: 25,
				},
			],
		},
		textColors: {
			title: "text_colors",
			autoGenerate: true,
			bottomAxis: { start: 40, end: 60 },
			topAxis: { start: 60, end: 100 },
			list: [
				{
					name: "text-color-1",
					value: "#ececec",
					visible: true,
					generationStep: 0,
				},
				{
					name: "text-color-2",
					value: "#fffcfc",
					visible: true,
					generationStep: 20,
				},
				{
					name: "text-color-3",
					value: "#f5eaf9",
					visible: true,
					generationStep: 30,
				},
				{
					name: "text-color-4",
					value: "#ecddee",
					visible: true,
					generationStep: 40,
				},
			],
		},
	},
	backgroundImage: true,
	timezone: {
		allowPositionChange: true,
	},
};
export default template4;
